import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { centerDivContainer, pecrIdDiv, ReviewMessage } from '../../styles';
function AlreadySubmitted(props) {
  const { t } = useTranslation();
  const { pecrId, insertId, pecrTitle } = props;
  return (
    <>
      <div style={ReviewMessage}>{t('PECR_has_already_submitted')}</div>
      {(pecrId || props.insertId) && (
        <div>
          <div style={pecrIdDiv}>
            <div style={centerDivContainer}>
              <h4> {pecrTitle}</h4>
              <h4> ({insertId || pecrId})</h4>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

AlreadySubmitted.propTypes = {
  pecrId: PropTypes.string,
  insertId: PropTypes.string,
  pecrTitle: PropTypes.string.isRequired,
};

export default AlreadySubmitted;
